// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2T8wi","sectionsWrapper":"style_sectionsWrapper__2ti9J"};